import type { Element } from "React";
type Props = {
  className?: string;
};

const IconLogo = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="24"
    viewBox="0 0 43 24"
    className={props.className}
  >
    <title>3ET</title>
    <g>
      <g transform="translate(0 .042)">
        <mask fill="#fff">
          <path d="M0 .395h42.964v23.169H0z" />
        </mask>
        <path
          fill="#FFF"
          d="M20.88 12.957c.2-1.142.624-2.053 1.276-2.735.651-.68 1.507-1.02 2.567-1.02 1.06 0 1.91.345 2.55 1.037.64.691 1.038 1.598 1.193 2.718H20.88zm17.037 4.408v-7.57h1.186l3.861-4.284h-5.047V.395h-5.035V11.26l-.027-.099a8.818 8.818 0 0 0-1.59-3.064 7.815 7.815 0 0 0-2.7-2.124c-1.082-.527-2.363-.79-3.842-.79-1.303 0-2.49.241-3.56.724a8.469 8.469 0 0 0-2.767 1.977 9.024 9.024 0 0 0-1.805 2.931c-.12.311-.22.627-.307.949A7.545 7.545 0 0 0 12.65 8.85l4.128-4.682V.395h-2.076L3.273 12.739h6.613c1.844 0 3.343 1.467 3.343 3.314 0 1.846-1.498 3.314-3.34 3.314H0v4.115h9.89a7.631 7.631 0 0 0 7.064-4.669 8.57 8.57 0 0 0 1.625 2.214 8.54 8.54 0 0 0 2.947 1.878c1.138.44 2.369.659 3.693.659 1.613 0 3.015-.291 4.207-.873a8.925 8.925 0 0 0 3.048-2.421l-2.882-2.537c-.707.637-1.391 1.099-2.054 1.383-.662.286-1.413.43-2.252.43-1.126 0-2.07-.292-2.832-.874-.762-.581-1.265-1.444-1.507-2.586h11.935v2.076c0 1.032.127 1.883.381 2.552.254.67.607 1.214 1.06 1.631a3.75 3.75 0 0 0 1.623.873c.63.165 1.33.247 2.104.247.839 0 1.578-.094 2.219-.28a7.835 7.835 0 0 0 1.756-.741v-4.02a4.944 4.944 0 0 1-2.485.66c-1.082 0-1.623-.573-1.623-1.72z"
        />
      </g>
      <path fill="#4DA1A9" d="M8.603 4.55L12.527.437H0v4.115h3.36z" />
    </g>
  </svg>
);

export default IconLogo;
